import script from "./RadioButton.vue?vue&type=script&setup=true&lang=ts&generic=T%20extends%20string%7Cnumber%7Csymbol"
export * from "./RadioButton.vue?vue&type=script&setup=true&lang=ts&generic=T%20extends%20string%7Cnumber%7Csymbol"

import "./RadioButton.vue?vue&type=style&index=0&id=21aa40f0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21aa40f0"]])

export default __exports__